import { EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

export abstract class CardInputsAbstractInput {
    @Input('form') form: FormGroup;
    @Input('index') index: number;
    @Input('cardIndex') cardIndex: number;
    @Input('dataCheckout') useDataCheckout = false;
    @Output('keyUp') keyUp: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
    @Output('blur') blur: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
    @Output('change') change: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
    @Output('error') error: EventEmitter<any> = new EventEmitter<any>();

    public focused = false;
    public control: FormControl;

    /**
     * Emit keyUp event.
     **/
    public emitKeyUp() {
        this.keyUp.emit(this.form);
    }
    /**
     * Emit change event.
     **/
    public emitChange() {
        this.change.emit(this.form);
    }
    /**
     * Emit blur event.
     **/
    public emitBlur() {
        this.blur.emit(this.form);
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3894461559/src/src/app/card-inputs/card-inputs.abstract-input.ts